/**
 * This component wraps React-Router's Navigate by providing name-based routing.
 * (Helps to narrow down the scope of possible format changes to routes.)
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { pathByRouteName } from '../../util/routes';

const NamedRedirect = props => {
  const routeConfiguration = useRouteConfiguration();
  const { name, search = '', state = {}, params = {}, push = false } = props;
  const pathname = pathByRouteName(name, routeConfiguration, params);
  return <Navigate to={{ pathname, search }} state={state} replace={!push} />;
};

const { bool, object, string } = PropTypes;

NamedRedirect.propTypes = {
  name: string.isRequired,
  search: string,
  state: object,
  push: bool,
  params: object,
};

export default NamedRedirect;
